var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLightning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4775 2.75H10.499C11.5277 2.75005 12.5714 2.99524 13.501 3.4502V3.45117C14.4384 3.9154 15.2617 4.59753 15.8848 5.42871C16.512 6.26545 16.948 7.24302 17.1367 8.2627C17.3263 9.28722 17.2782 10.3602 16.9941 11.3643C16.7112 12.3645 16.1916 13.2936 15.4893 14.0732C14.7901 14.839 13.8982 15.4471 12.9307 15.8271C11.9577 16.2052 10.9061 16.348 9.86133 16.2529H9.8623C8.9357 16.1678 8.01886 15.8836 7.20898 15.4219L6.86816 15.2285L6.51465 15.3965L2.87402 17.1299L4.61133 13.4805L4.77637 13.1318L4.58984 12.7939C4.05677 11.8319 3.75513 10.762 3.73633 9.6709V9.66016C3.69865 8.46063 3.99159 7.26841 4.57812 6.21777C5.16682 5.16341 6.01919 4.28366 7.05664 3.67969L7.05957 3.67871C8.09092 3.07283 9.27477 2.75002 10.4775 2.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightning);
export default __webpack_public_path__ + "static/media/icon-lightning.3f559010.svg";
export { ForwardRef as ReactComponent };